import * as React from "react";
import { StyledButton } from "../../Layout/Inputs/StyledButton";
import { ReadOnlyProps } from "../../Project/EditProject/ReadOnlyProps";

type Props = {
  onClick: () => void;
};

export const SetForAllCutOff = ({ onClick, isReadOnly }: Props & ReadOnlyProps) => {
  return (
    <StyledButton onClick={onClick} themeColor="primary" width="100%" isReadOnly={isReadOnly}>
      Set Value For Current Filter
    </StyledButton>
  );
};
